import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateDistributionRecipientType extends Enum {
  static MAIN = {
    key: 'main',
    get value() {
      return Lang.t('estatedistribution.main');
    }
  };

  static ALTERNATE = {
    key: 'alternate',
    get value() {
      return Lang.t('estatedistribution.alternate');
    }
  };
}
